import { carePlanRequestsTyped } from "@/api/(requests)/carePlanTyped";
import type { GoalsAndObjectivesResponse } from "@/core/types";

export async function getGoalsAndObjectives(
  patientId: string,
): Promise<GoalsAndObjectivesResponse> {
  return carePlanRequestsTyped.get_goals_and_objectives({
    context: { showLoader: false },
    urlParams: { patientId },
  });
}
